import PropTypes from 'prop-types';

import { Helmet, HelmetProvider } from 'react-helmet-async';
import { useLocation } from 'react-router-dom';
import i18n from '~/i18n';
import logoPNG from '~/images/bdtk.png';

const PageHeaderMeta = props => {
	let location = useLocation();

	const title = props.page_title ? props.page_title + ' | Bodytalk' : 'Bodytalk';
	const type = props.type ? props.type : 'website';
	const url = 'https://www.bodytalk.com' + location.pathname;
	const image = props.image ? props.image : window.location.origin + logoPNG;
	const locale = i18n.language === 'el' ? 'el_GR' : i18n.language === 'ro' ? 'ro_RO' : 'en_US';
	const status = props.status;
	const description = props.meta_description;
	const keywords = props.meta_keywords;

	const renderMetaKeywords = () => {
		if (keywords != null) {
			return <meta name="keywords" content={keywords} />;
		}

		return null;
	};

	const renderMetaDescription = () => {
		if (description != null) {
			return <meta name="description" content={description} />;
		}

		return null;
	};

	const renderOpenGraphDescription = () => {
		if (description != null) {
			return <meta property="og:description" content={description} />;
		}

		return null;
	};

	const renderProductPrice = () => {
		if (props.product_price != null) {
			return <meta property="product:price:amount" content={props.product_price} />;
		}

		return null;
	};
	const renderProductCurrency = () => {
		if (props.product_price != null) {
			return <meta property="product:price:currency" content="EUR" />;
		}

		return null;
	};

	const renderRobotsMeta = () => {
		if (props.disable_indexation || props.disable_follow) {
			const content = `${props.disable_indexation ? 'noindex' : 'index'},${props.disable_follow ? 'nofollow' : 'follow'}`;
			return <meta name="robots" content={content} />;
		}
		return null;
	};

	const renderCanonicalLink = () => {
		if (props.canonical_url) {
			return <link rel="canonical" href={props.canonical_url} />;
		}
		return <link rel="canonical" href={url} />;
	};

	const lang = localStorage.getItem('I18N_LANGUAGE');

	return (
		<HelmetProvider>
			<Helmet>
				<html lang={lang ?? 'el'} />
				<meta charset="utf-8" />
				{/*<meta name="robots" content="noindex" />*/}
				<title>{title}</title>
				<meta property="og:site_name" content="Bodytalk" />
				<meta property="og:title" content={title} />
				<meta property="og:type" content={type} />
				<meta property="og:url" content={url} />
				<meta property="og:image" content={image} />
				<meta property="og:image:url" content={image} />
				<meta property="og:locale" content={locale} />
				{status && <meta name="prerender-status-code" content={status} />}

				<link rel="canonical" href={url} />

				{renderRobotsMeta()}
				{renderCanonicalLink()}
				{renderMetaKeywords()}
				{renderMetaDescription()}
				{renderOpenGraphDescription()}
				{renderProductPrice()}
				{renderProductCurrency()}
			</Helmet>
		</HelmetProvider>
	);
};

PageHeaderMeta.propTypes = {
	page_title: PropTypes.string,
	meta_keywords: PropTypes.string,
	meta_description: PropTypes.string,
	type: PropTypes.string,
	image: PropTypes.string,
	product_price: PropTypes.number,
	status: PropTypes.number,
	disable_indexation: PropTypes.bool,
	disable_follow: PropTypes.bool,
	canonical_url: PropTypes.string
};

export default PageHeaderMeta;
